import * as React from 'react';
import clsx from 'clsx';
import { useAnimation } from '../../hooks';
import { Base } from '../Base';
import { Backdrop, NewLayer as Layer, Overlay, useOverlay } from '../Helper';
import DrawerContext from './DrawerContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "slideIn": "Drawer-slideIn_2959d",
  "slideOut": "Drawer-slideOut_bRAVi",
  "root": "Drawer-root_3rCDx",
  "top": "Drawer-top_3FV3W",
  "right": "Drawer-right_3LfYy",
  "bottom": "Drawer-bottom_3JRhi",
  "left": "Drawer-left_1OuxK"
};
function Box({
  position,
  className,
  ...extraProps
}) {
  const rootClasses = clsx(styles.root, {
    [styles.top]: position === 'top',
    [styles.right]: position === 'right',
    [styles.bottom]: position === 'bottom',
    [styles.left]: position === 'left'
  }, className);
  const layout = ['right', 'left'].includes(position) ? {
    flex: true,
    flexCol: true
  } : {};
  return /*#__PURE__*/_jsx(Base, {
    position: "fixed",
    backgroundColor: "white",
    className: rootClasses,
    ...layout,
    ...extraProps
  });
}
function ModalImpl({
  children,
  close = () => {},
  ...extraProps
}) {
  const boxRef = React.useRef(null);
  const identifier = React.useId();
  const context = React.useMemo(() => ({
    labelId: identifier ? `drawer-${identifier}-label` : undefined
  }), [identifier]);
  const {
    overlayProps
  } = useOverlay({
    onClose: close
  }, boxRef);
  return /*#__PURE__*/_jsx(Box, {
    innerRef: boxRef,
    "aria-modal": true,
    role: "dialog",
    tabIndex: "-1",
    "aria-labelledby": context.labelId,
    ...overlayProps,
    ...extraProps,
    children: /*#__PURE__*/_jsx(DrawerContext.Provider, {
      value: context,
      children: children
    })
  });
}
function Modal({
  open = false,
  style: styleProp,
  close,
  ...extraProps
}) {
  const {
    render,
    onAnimationEnd
  } = useAnimation({
    visible: open
  });
  const style = {
    '--animation': open ? 'var(--animation-in)' : 'var(--animation-out)'
  };
  return render ? /*#__PURE__*/_jsxs(Layer, {
    children: [/*#__PURE__*/_jsx(Backdrop, {
      onAnimationEnd: onAnimationEnd,
      style: style
    }), /*#__PURE__*/_jsx(Overlay, {
      preventBodyScroll: true,
      children: /*#__PURE__*/_jsx(ModalImpl, {
        close: close,
        style: {
          ...styleProp,
          ...style
        },
        ...extraProps
      })
    })]
  }) : null;
}
function NonModal({
  open = false,
  style: styleProp,
  ...extraProps
}) {
  const {
    render,
    onAnimationEnd
  } = useAnimation({
    visible: open
  });
  const style = {
    ...styleProp,
    '--animation': open ? 'var(--animation-in)' : 'var(--animation-out)'
  };
  return render ? /*#__PURE__*/_jsx(Layer, {
    children: /*#__PURE__*/_jsx(Box, {
      onAnimationEnd: onAnimationEnd,
      style: style,
      ...extraProps
    })
  }) : null;
}
function Drawer({
  position = 'bottom',
  open,
  close,
  modal,
  children,
  className,
  style
}) {
  if (modal) {
    return /*#__PURE__*/_jsx(Modal, {
      close: close,
      open: open,
      position: position,
      className: className,
      style: style,
      children: children
    });
  }
  return /*#__PURE__*/_jsx(NonModal, {
    open: open,
    position: position,
    className: className,
    style: style,
    children: children
  });
}
export default Drawer;